import { render, staticRenderFns } from "./PzList.vue?vue&type=template&id=6760652b&scoped=true&"
import script from "./PzList.vue?vue&type=script&lang=js&"
export * from "./PzList.vue?vue&type=script&lang=js&"
import style0 from "./PzList.vue?vue&type=style&index=0&id=6760652b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760652b",
  null
  
)

export default component.exports